import React from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const OwnerRoleChangeWarningView = ({
    show,
    handleClose,
    user,
}) => {
    return (
        <Modal show={show} onHide={handleClose} className="frmModalArea ModifyModal">
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <h5 className="h5Title mb-5">Owner Role Change Warning</h5>
                <Row>
                    <Col md="12">
                        <p className="mb-4">
                            {user?.first_name} {user?.last_name} has a special "Owner" position that must be assigned to a Company Manager. The "Owner" must reassign that position to another Company Manager using the hyperlink "Owner" under Company Role, before their role can be changed from Company Manager.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col md="12">
                        <div className="mdlFtBar ftBdr ownerRoleChangeBtnDiv">
                            <button
                                className="fillPrimarBtn InviteBtn send btn btn-secondary"
                                type="button"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                        </div>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    );
};

export default OwnerRoleChangeWarningView;
